module.exports = __webpack_public_path__ + "img/logo-light.33749b06.svg";